<template>
  <div class="block-list-item">
    <!--googleoff: noindex-->
    <TeaserListItem
      v-bind="props"
      class="list-item"
      tag="button"
      justify-content="center"
      :padded="padded"
      :loading="loading"
      :priority="priority"
      :show-date="showDate"
      :show-label="true"
      :heading-level="headingLevel"
      :analytics="analytics"
      :aria-hidden="!isMobile"
      :is-video="true"
      @click="globalShort ? openShortModal() : emits('click')"
    />
    <!--googleon: noindex-->
    <TeaserPoster
      v-bind="props"
      :fluid="fluid"
      tag="button"
      :renditions="renditions"
      :is-video="true"
      :show-label="false"
      heading-size="title-xs"
      class="short-poster"
      :analytics="analytics"
      aria-label-prefix="Bekijk short:"
      aria-label="in Overlay"
      @click="globalShort ? openShortModal() : emits('click')"
    />
  </div>
</template>

<script setup lang="ts">
// switches between list-item and block based on breakpoint (using css)
import type {
  IAnalytics,
  IImageLoadingSettings,
  IImageRendition,
  ITeaser,
  TAspectRatio,
} from '~~/types/local_types';
import useBreakpointsStore from '~/stores/breakpoints';
import useShortStore from '~/stores/short';
const breakpointsStore = useBreakpointsStore();
const { getCurrentBreakpoint } = storeToRefs(breakpointsStore);

const isMobile = ref<boolean>(true);
const { setShort } = useShortStore();
const emits = defineEmits(['click']);

interface IProps extends ITeaser, IImageLoadingSettings {
  padded?: boolean;
  showDate?: boolean;
  headingLevel?: number;
  analytics?: IAnalytics;
  fluid?: boolean;
  globalShort?: boolean;
  _index?: number;
}

const props = withDefaults(defineProps<IProps>(), {
  loading: 'lazy',
  priority: 'auto',
  padded: false,
  showDate: true,
  headingLevel: 3,
  analytics: undefined,
  fluid: false,
  globalShort: true,
  _index: 0,
});

const renditions: IImageRendition[] = [
  {
    breakpoint: 'sm',
    size: 480,
    aspectRatio: '2x3' as TAspectRatio,
  },
];

onMounted(() => {
  watch(
    getCurrentBreakpoint,
    (newValue) => {
      if (newValue) {
        isMobile.value = ['xs', 'sm'].includes(newValue?.name);
      }
    },
    { immediate: true },
  );
});

const openShortModal = () => {
  if (props.globalShort) {
    setShort(props as ITeaser);
  }
};
</script>

<style scoped lang="postcss">
.block-list-item {
  display: contents;
}

.list-item {
  @media (--md-viewport) {
    display: none;
    visibility: hidden;
  }
}

.short-poster {
  display: none;
  visibility: hidden;
  @media (--md-viewport) {
    display: block;
    visibility: visible;
  }
}
</style>
